/* ============================================================
   Rudie — Coming Soon lander
   ============================================================ */

/* CONFIG comes from Shopify theme settings, injected as window.RUDIE in theme.liquid
   (Theme editor → Theme settings → "Email capture" + "Launch"). Falls back to defaults. */
const R = (typeof window !== "undefined" && window.RUDIE) || {};
const KLAVIYO = {
  COMPANY_ID: (R.klaviyo && R.klaviyo.company) || "",
  LIST_ID:    (R.klaviyo && R.klaviyo.list)    || "",
};
const SUCCESS_MSG = R.success || "You're in. We'll see you on 30 June. ✦";
const LAUNCH_DATE = new Date(R.launch || "2026-06-30T00:00:00+10:00");

/* Build a clean, privacy-friendly embed from a YouTube/Vimeo/MP4 URL */
function rudieEmbed(url){
  url = (url || "").trim();
  if(!url) return "";
  let m;
  if(m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/)){
    return `<iframe src="https://www.youtube-nocookie.com/embed/${m[1]}?autoplay=0&rel=0&modestbranding=1&playsinline=1" title="The Rudie Recovery" allow="fullscreen; picture-in-picture" allowfullscreen></iframe>`;
  }
  if(m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/)){
    return `<iframe src="https://player.vimeo.com/video/${m[1]}?autoplay=0&title=0&byline=0&portrait=0" title="The Rudie Recovery" allow="fullscreen; picture-in-picture" allowfullscreen></iframe>`;
  }
  return `<video src="${url}" controls autoplay playsinline></video>`;
}

/* ---------- Countdown ---------- */
(function countdown(){
  if(!document.querySelector("[data-cd]")) return;
  const pad = n => String(Math.max(0,n)).padStart(2,"0");
  const set = (name,val) => document.querySelectorAll('[data-cd="'+name+'"]').forEach(e => e.textContent = val);
  function tick(){
    const diff = LAUNCH_DATE - new Date();
    const s = diff > 0 ? Math.floor(diff/1000) : 0;
    set("days",  pad(Math.floor(s/86400)));
    set("hours", pad(Math.floor((s%86400)/3600)));
    set("mins",  pad(Math.floor((s%3600)/60)));
    set("secs",  pad(s%60));
  }
  tick();
  setInterval(tick, 1000);
})();

/* ---------- Materials: select a benefit, swap the image ---------- */
(function materials(){
  const benefits = document.querySelectorAll(".benefit");
  const img = document.querySelector("[data-mat-img]");
  if(!benefits.length || !img) return;

  benefits.forEach(b => b.addEventListener("click", () => {
    benefits.forEach(x => { x.classList.remove("is-active"); x.setAttribute("aria-selected","false"); });
    b.classList.add("is-active");
    b.setAttribute("aria-selected","true");
    if(b.dataset.img === img.getAttribute("src")) return;
    img.classList.add("is-fading");
    setTimeout(() => {
      img.src = b.dataset.img;
      img.classList.remove("is-fading");
    }, 240);
  }));
})();

/* ---------- Video: swap placeholder for real embed on click ---------- */
(function video(){
  const frame = document.querySelector(".video-frame");
  if(!frame) return;
  const ph = frame.querySelector(".video-placeholder");
  if(!ph) return;
  ph.addEventListener("click", () => {
    const url = (ph.dataset.embed || "").trim();
    if(!url){
      console.warn("[Rudie] No video set. Add a URL to data-embed on .video-placeholder (see README).");
      return;
    }
    // YouTube / Vimeo => iframe; otherwise treat as direct MP4
    frame.innerHTML = rudieEmbed(url);
  });
})();

/* ---------- Hero video: play button opens a lightbox ---------- */
(function heroVideo(){
  const btn = document.querySelector(".vhero__play");
  if(!btn) return;
  btn.addEventListener("click", () => {
    const url = (btn.dataset.video || "").trim();
    if(!url){ console.warn("[Rudie] No play-button video set."); return; }
    const modal = document.createElement("div");
    modal.className = "vmodal";
    modal.innerHTML = `<div class="vmodal__inner">
      <button class="vmodal__close" aria-label="Close">&times;</button>
      ${rudieEmbed(url)}
    </div>`;
    document.body.appendChild(modal);
    const close = () => modal.remove();
    modal.addEventListener("click", e => {
      if(e.target === modal || e.target.classList.contains("vmodal__close")) close();
    });
    document.addEventListener("keydown", function esc(e){ if(e.key==="Escape"){ close(); document.removeEventListener("keydown", esc); } });
  });
})();

/* ---------- Banner click → scroll to sign-up & focus email ---------- */
(function bannerFocus(){
  document.querySelectorAll("[data-focus-target]").forEach(a => {
    a.addEventListener("click", () => {
      const target = document.querySelector(a.getAttribute("data-focus-target"));
      if(!target) return;
      const input = target.querySelector('input[type="email"]');
      if(input) setTimeout(() => input.focus({ preventScroll: true }), 600);
    });
  });
})();

/* ---------- Klaviyo email capture ---------- */
(function klaviyoForms(){
  const forms = document.querySelectorAll(".klaviyo-form");

  async function subscribe(email){
    // Preferred: Cloudflare Worker proxy (server-side subscribe, reliable) — same as the live site
    const proxy = (R.proxy || "").trim();
    if(proxy){
      const res = await fetch(proxy, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      if(!res.ok) throw new Error("proxy " + res.status);
      return { demo:false };
    }
    // Fallback: Klaviyo client API (less reliable) or demo mode if unconfigured
    if(!KLAVIYO.COMPANY_ID || !KLAVIYO.LIST_ID){
      await new Promise(r => setTimeout(r, 500));
      return { demo:true };
    }
    const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO.COMPANY_ID}`,{
      method:"POST",
      headers:{ "Content-Type":"application/json", "revision":"2024-10-15" },
      body: JSON.stringify({ data:{ type:"subscription", attributes:{ profile:{ data:{ type:"profile", attributes:{ email } } } }, relationships:{ list:{ data:{ type:"list", id: KLAVIYO.LIST_ID } } } } })
    });
    if(!res.ok && res.status !== 202) throw new Error("Klaviyo "+res.status);
    return { demo:false };
  }

  forms.forEach(form => {
    form.addEventListener("submit", async e => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const btn   = form.querySelector('button[type="submit"]');
      const msg   = form.querySelector(".form-msg");
      const email = (input.value||"").trim();
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){
        msg.textContent = "Please enter a valid email."; msg.className = "form-msg is-err"; return;
      }
      btn.disabled = true; const label = btn.textContent; btn.textContent = "Joining…";
      msg.textContent = ""; msg.className = "form-msg";
      try{
        const r = await subscribe(email);
        form.querySelector(".field").style.display = "none";
        msg.className = "form-msg is-ok";
        msg.textContent = r.demo
          ? "You're on the list! (Demo mode — add Klaviyo keys in Theme settings to go live.)"
          : SUCCESS_MSG;
        // GA4 conversion: real signups only (skip demo mode). Fires the sign_up key event.
        if(!r.demo && window.gtag){ try{ window.gtag('event','sign_up',{ method:'email_lander' }); }catch(e){} }
      }catch(err){
        console.error(err);
        btn.disabled = false; btn.textContent = label;
        msg.className = "form-msg is-err";
        msg.textContent = "Something went wrong — please try again.";
      }
    });
  });
})();
